<template>
  <div class="container-fluid">
    <div class="forget-password">
      <div class="card p-sm-5" style="width: 25rem">
        <h5 class="card-title text-center text-white">
          <img src="/assets/logo/logo_white.svg" alt="" />
        </h5>
        <div class="card-body pt-0">
          <form @submit.prevent="submit()">
            <div class="form-group mt-3">
              <p class="text-white text-uppercase">Wachtwoord vergeten?</p>
            </div>
            <div class="form-group mt-3">
              <p class="text-white">
                Vul hieronder je gebruikersnaam of emailadres in en wij sturen
                je de instructies toe om jouw wachtwoord te resetten.
              </p>
            </div>

            <div class="form-group mt-4 p-1">
              <input
                type="text"
                class="form-control"
                placeholder="Gebruikersnaam/Emailadres"
                v-model="username"
                name="username"
              />
            </div>
            <div class="form-group text-center">
              <button type="submit" class="btn btn-dark mt-2">
                <span v-if="loading">Versturen...</span>
                <span v-else>Opvragen</span>
              </button>
            </div>
          </form>
        </div>
        <div class="form-group text-white mt-6">
          <router-link class="text-white" to="/login"
            ><i class="fa fa-arrow-left mr-2"></i> Login</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "forgetPassword",
  data() {
    return {
      username: "",
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      displayNotification: "auth/displayNotification",
    }),

    submit() {
      this.loading = true;
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/forgot-password",
          details: { username: this.username },
        })
        .then((data) => {
          this.loading = false;
          console.log(data);
          this.displayNotification({
            type: "success",
            title: "Success",
            message:
              "Er is een email naar je verzonden om je wachtwoord opnieuw in te stellen",
            id: Math.round(Math.random() * 999),
            autoDismiss: true,
            interval: 2000,
          });
        })
        .catch((error) => {
          console.log(error.request);

          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.container-fluid {
  height: 100vh;
  background: transparent linear-gradient(270deg, #73afe3 0%, #cfe4f6 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}

.forget-password {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 20px;
  opacity: 1;
}

.form-control {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  height: calc(1.5em + 0.75rem + 8px) !important;
  font-size: 15px !important;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 15%;
  padding-right: 15%;
  font-size: 18px !important;
}
</style>
